/* cs-animations.js — Shoe Doc custom sections */

(function () {

  // =========================
  // SCROLL REVEAL
  // =========================
  function initReveal(scope) {

    var els = (scope || document).querySelectorAll('.cs-reveal:not(.is-visible)');

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {

      entries.forEach(function (e) {

        if (!e.isIntersecting) return;

        var delay = parseInt(
          e.target.getAttribute('data-cs-delay') || '200',
          10
        );

        setTimeout(function () {
          e.target.classList.add('is-visible');
        }, delay);

        io.unobserve(e.target);

      });

    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) {
      io.observe(el);
    });

  }


  // =========================
  // FAQ ACCORDION
  // =========================
  function initFaq(scope) {

    var items = (scope || document).querySelectorAll('.cs-faq-item');

    items.forEach(function (item) {

      var question = item.querySelector('.cs-faq-q');

      if (!question || question.dataset.bound) return;

      question.dataset.bound = 'true';

      question.addEventListener('click', function () {

        var isOpen = item.classList.contains('is-open');

        items.forEach(function (faq) {
          faq.classList.remove('is-open');
        });

        if (!isOpen) {
          item.classList.add('is-open');
        }

      });

    });

  }


  // =========================
  // INIT ALL
  // =========================
  function initAll(scope) {

    initReveal(scope);
    initFaq(scope);

  }


  // =========================
  // DOM READY
  // =========================
  if (document.readyState !== 'loading') {

    initAll(document);

  } else {

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });

  }


  // =========================
  // SHOPIFY EDITOR SUPPORT
  // =========================
  document.addEventListener('shopify:section:load', function (e) {

    initAll(e.target);

  });

})();



/* Accordion */
document.querySelectorAll('.faq-q').forEach(q => {
  q.addEventListener('click', () => {
    const item = q.closest('.faq-item');
    const isOpen = item.classList.contains('active');
    document.querySelectorAll('.faq-item').forEach(i => {
      i.classList.remove('active');
      i.querySelector('.faq-chevron svg').innerHTML = '<polyline points="6 9 12 15 18 9"/>';
    });
    if (!isOpen) {
      item.classList.add('active');
      item.querySelector('.faq-chevron svg').innerHTML = '<polyline points="18 15 12 9 6 15"/>';
    }
  });
});

/* Live search filter */
document.getElementById('faqSearch').addEventListener('input', function(){
  const q = this.value.toLowerCase().trim();
  document.querySelectorAll('.faq-item').forEach(item => {
    const text = item.textContent.toLowerCase();
    item.style.display = (!q || text.includes(q)) ? '' : 'none';
  });
  document.querySelectorAll('.faq-category').forEach(cat => {
    const visible = [...cat.querySelectorAll('.faq-item')].some(i => i.style.display !== 'none');
    cat.style.display = visible ? '' : 'none';
  });
});

document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.cat-btn');

  buttons.forEach(function(button) {

    button.addEventListener('click', function() {

      buttons.forEach(function(btn) {
        btn.classList.remove('active');
      });

      this.classList.add('active');

      const targetId = this.getAttribute('data-target');
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    });

  });

});

